import React from "react";
import { useSelector } from "react-redux";
import one from '../../assest/light.jpg';
import two from '../../assest/lightone.jpg';
import three from '../../assest/lighttwo.jpg';
// Images
import excavatorImg from '../../assest/heavy.jpg';
import FaqSection from "../../components/about/FAQ";
import ServicesCard from "../../components/home/ServicesCard";

const translations = {
    gb: {
        heading: "Light Equipment",
        buttonText: "Explore Light Equipment",
        introText: "Our light equipment range offers versatile solutions for small to medium-scale projects. Perfect for construction, landscaping, and maintenance tasks, our machines provide exceptional maneuverability, efficiency, and ease of use in tight spaces.",
        categoriesTitle: "Our Light Equipment Models",
        featuredTitle: "Featured Light Equipment",
        featuredDescription: "Light equipment includes compact machinery designed for precision work in confined areas, offering the perfect balance of power and agility for various construction and maintenance applications.",
        whyChooseTitle: "Why Choose Our Light Equipment?",
        features: [
            {
                title: "Compact & Efficient",
                text: "Our light equipment is designed for optimal performance in tight spaces without compromising power."
            },
            {
                title: "Easy Operation",
                text: "User-friendly controls and comfortable operation for all skill levels."
            },
            {
                title: "Versatile Solutions",
                text: "Wide range of attachments available for multiple applications."
            }
        ],
        equipmentList: [
            {
                name: "Mini Excavator",
                specs: "Ideal for small digging tasks, landscaping, and utility work in tight spaces.",
                description: "Compact and versatile mini excavators perfect for residential projects and confined area work with zero tail swing options.",
            },
            {
                name: "Skid Steer Loader",
                specs: "Compact loader with multiple attachment options for various tasks.",
                description: "Highly maneuverable skid steer loaders with quick-attach systems for efficient material handling and site preparation.",
            },
            {
                name: "Compact Track Loader",
                specs: "Low ground pressure machine ideal for delicate surfaces and all-terrain work.",
                description: "Track loaders provide superior traction and stability on uneven or soft ground conditions.",
            }
        ],
        specsLabel: "Specs:"
    },
    sa: {
        heading: "المعدات الخفيفة",
        buttonText: "استكشف المعدات الخفيفة",
        introText: "تقدم مجموعة المعدات الخفيفة لدينا حلولاً متعددة الاستخدامات للمشاريع الصغيرة والمتوسطة. مثالية لمهام البناء وتنسيق الحدائق والصيانة، توفر آلاتنا قدرة استثنائية على المناورة والكفاءة وسهولة الاستخدام في المساحات الضيقة.",
        categoriesTitle: "موديلات المعدات الخفيفة لدينا",
        featuredTitle: "المعدات الخفيفة المميزة",
        featuredDescription: "تشمل المعدات الخفيفة آلات مصممة للعمل الدقيق في المناطق الضيقة، وتوفر التوازن المثالي بين القوة وخفة الحركة لتطبيقات البناء والصيانة المختلفة.",
        whyChooseTitle: "لماذا تختار معداتنا الخفيفة؟",
        features: [
            {
                title: "مضغوطة وفعالة",
                text: "تم تصميم معداتنا الخفيفة لأداء مثالي في المساحات الضيقة دون المساس بالقوة."
            },
            {
                title: "تشغيل سهل",
                text: "ضوابط سهلة الاستخدام وتشغيل مريح لجميع مستويات المهارة."
            },
            {
                title: "حلول متعددة الاستخدامات",
                text: "مجموعة واسعة من الملحقات المتاحة لتطبيقات متعددة."
            }
        ],
        equipmentList: [
            {
                name: "حفارة صغيرة",
                specs: "مثالية لأعمال الحفر الصغيرة وتنسيق الحدائق والأعمال الخدمية في المساحات الضيقة.",
                description: "حفارات صغيرة مدمجة ومتعددة الاستخدامات مثالية للمشاريع السكنية وأعمال المناطق الضيقة مع خيارات عدم التأرجح الخلفي.",
            },
            {
                name: "لودر انزلاقي التوجيه",
                specs: "لودر مضغوط مع خيارات متعددة للملحقات لمهام مختلفة.",
                description: "لوادر انزلاقية التوجيه عالية المناورة مع أنظمة التثبيت السريع للمناولة الفعالة للمواد وإعداد الموقع.",
            },
            {
                name: "لودر مزود بجنزير",
                specs: "آلة ذات ضغط منخفض على الأرض مثالية للأسطح الحساسة وجميع أنواع التضاريس.",
                description: "توفر اللوادر المزودة بجنازير جرًا واستقرارًا فائقًا في ظروف الأرض غير المستوية أو الناعمة.",
            }
        ],
        specsLabel: "المواصفات:"
    },
    fr: {
        heading: "Équipement Léger",
        buttonText: "Explorer l'équipement léger",
        introText: "Notre gamme d'équipements légers offre des solutions polyvalentes pour des projets de petite à moyenne envergure. Parfaits pour les travaux de construction, d'aménagement paysager et d'entretien, nos machines offrent une maniabilité, une efficacité et une facilité d'utilisation exceptionnelles dans les espaces restreints.",
        categoriesTitle: "Nos modèles d'équipement léger",
        featuredTitle: "Équipement léger en vedette",
        featuredDescription: "L'équipement léger comprend des machines compactes conçues pour un travail de précision dans des zones confinées, offrant le parfait équilibre entre puissance et agilité pour diverses applications de construction et d'entretien.",
        whyChooseTitle: "Pourquoi choisir notre équipement léger?",
        features: [
            {
                title: "Compact et efficace",
                text: "Notre équipement léger est conçu pour des performances optimales dans les espaces restreints sans compromettre la puissance."
            },
            {
                title: "Utilisation facile",
                text: "Commandes conviviales et fonctionnement confortable pour tous les niveaux de compétence."
            },
            {
                title: "Solutions polyvalentes",
                text: "Large gamme d'accessoires disponibles pour de multiples applications."
            }
        ],
        equipmentList: [
            {
                name: "Mini Pelle",
                specs: "Idéale pour les petits travaux d'excavation, d'aménagement paysager et les travaux utilitaires dans les espaces restreints.",
                description: "Pelles miniatures compactes et polyvalentes parfaites pour les projets résidentiels et les travaux dans des zones confinées avec des options de zéro déport arrière.",
            },
            {
                name: "Chargeuse Compacte",
                specs: "Chargeuse compacte avec plusieurs options d'accessoires pour diverses tâches.",
                description: "Chargeuses compactes très maniables avec systèmes d'attache rapide pour une manutention efficace des matériaux et une préparation du site.",
            },
            {
                name: "Chargeuse à Chenilles Compacte",
                specs: "Machine à faible pression au sol idéale pour les surfaces délicates et les travaux tout-terrain.",
                description: "Les chargeuses à chenilles offrent une traction et une stabilité supérieures sur des sols inégaux ou meubles.",
            }
        ],
        specsLabel: "Caractéristiques:"
    },
    de: {
        heading: "Leichte Ausrüstung",
        buttonText: "Leichte Ausrüstung erkunden",
        introText: "Unser Sortiment an leichten Geräten bietet vielseitige Lösungen für kleine bis mittelgroße Projekte. Perfekt für Bau-, Landschaftsbau- und Wartungsarbeiten bieten unsere Maschinen außergewöhnliche Manövrierfähigkeit, Effizienz und einfache Handhabung in engen Räumen.",
        categoriesTitle: "Unsere Modelle der leichten Ausrüstung",
        featuredTitle: "Vorgestellte leichte Ausrüstung",
        featuredDescription: "Leichte Ausrüstung umfasst kompakte Maschinen, die für Präzisionsarbeiten in beengten Bereichen konzipiert sind und das perfekte Gleichgewicht zwischen Kraft und Wendigkeit für verschiedene Bau- und Wartungsanwendungen bieten.",
        whyChooseTitle: "Warum unsere leichte Ausrüstung wählen?",
        features: [
            {
                title: "Kompakt & effizient",
                text: "Unsere leichte Ausrüstung ist für optimale Leistung in engen Räumen ohne Kompromisse bei der Leistung konzipiert."
            },
            {
                title: "Einfache Bedienung",
                text: "Benutzerfreundliche Steuerungen und komfortable Bedienung für alle Könnensstufen."
            },
            {
                title: "Vielseitige Lösungen",
                text: "Breites Zubehörsortiment für verschiedene Anwendungen."
            }
        ],
        equipmentList: [
            {
                name: "Mini-Bagger",
                specs: "Ideal für kleine Grabungsarbeiten, Landschaftsbau und Versorgungsarbeiten in engen Räumen.",
                description: "Kompakte und vielseitige Mini-Bagger, perfekt für Wohnprojekte und Arbeiten in beengten Bereichen mit Null-Schwanzschwenk-Optionen.",
            },
            {
                name: "Kompaktlader",
                specs: "Kompakter Lader mit mehreren Anbaugeräte-Optionen für verschiedene Aufgaben.",
                description: "Höchst manövrierfähige Kompaktlader mit Schnellwechselsystemen für effizientes Materialhandling und Baustellenvorbereitung.",
            },
            {
                name: "Kompaktkettenlader",
                specs: "Maschine mit niedrigem Bodendruck, ideal für empfindliche Oberflächen und All-Terrain-Arbeiten.",
                description: "Kettenlader bieten überlegene Traktion und Stabilität auf unebenem oder weichem Boden.",
            }
        ],
        specsLabel: "Spezifikationen:"
    }
};

const imageStyle = {
    height: '250px',
    width: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
};

const LightEquipment = () => {
    const { language } = useSelector((state) => state.language);
    const t = translations[language] || translations.gb;

    return (
        <div>
            {/* Introduction Text */}
            <section
                style={{
                    background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)',
                    padding: '20px',
                }}
            >
                <h1 className="text-center mb-4 mt-5">{t.heading}</h1>
                <p
                    className="text-center mb-5 mx-auto"
                    style={{ fontSize: '1.1rem', maxWidth: '70%' }}
                >
                    {t.introText}
                </p>
            </section>

            {/* Equipment Models */}
            <section className="container py-5">
                <h2 className="text-center mb-4">{t.categoriesTitle}</h2>
                <div className="row text-center">
                    {t.equipmentList.map((item, idx) => (
                        <div className="col-md-4 mb-4" key={idx}>
                            <img src={[one, two, three][idx]} alt={item.name} style={imageStyle} />
                            <h5 className="mt-3">{item.name}</h5>
                            <p><strong>{t.specsLabel}</strong> {item.specs}</p>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Featured Equipment */}
            <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <h2 className="text-center mb-4">{t.featuredTitle}</h2>
                    <p className="text-center mb-4">{t.featuredDescription}</p>

                    <ul className="list-group">
                        {t.equipmentList.map((item, idx) => (
                            <li key={idx} className="list-group-item mb-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <img src={[one, two, three][idx]} alt={item.name} style={imageStyle} />
                                    </div>
                                    <div className="col-md-9">
                                        <h5>{item.name}</h5>
                                        <p>{item.description}</p>
                                        <p><strong>{t.specsLabel}</strong> {item.specs}</p>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <ServicesCard showHeading={false} showParagraph={false} />
            <FaqSection />
        </div>
    );
};

export default LightEquipment;